module.exports = __webpack_public_path__ + "img/InformationInstruction.867d9b2d.svg";